module.exports = __webpack_public_path__ + "static/media/manuals.8b0b8291.svg";